import { Axios } from '@utils/api/axios-instance';
import { POST_URL } from '@utils/api/endpoints';
import { TokenExtension } from '@utils/extensions/token.extension';
import { useMutation, UseMutationResult } from 'react-query';

interface ConfirmUploadCompletePayload {
  sessionId: string;
}

interface ConfirmUploadCompleteResponse {
  result: {
    session_id: string;
    status: string;
    filename: string;
    duration?: number;
    media_type?: string;
  };
}

const confirmUploadComplete = async (
  payload: ConfirmUploadCompletePayload
): Promise<ConfirmUploadCompleteResponse> => {
  const authToken = TokenExtension.get();

  const response = await Axios.post<ConfirmUploadCompleteResponse>(
    POST_URL(payload.sessionId).confirmUploadComplete,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken.string}`
      }
    }
  );

  return response.data;
};

export const useConfirmUploadComplete = (): UseMutationResult<
  ConfirmUploadCompleteResponse,
  Error,
  ConfirmUploadCompletePayload
> => {
  return useMutation(confirmUploadComplete);
};
